import { render, staticRenderFns } from "./ModalNuevoMail.vue?vue&type=template&id=843737fe&scoped=true&"
import script from "./ModalNuevoMail.vue?vue&type=script&lang=js&"
export * from "./ModalNuevoMail.vue?vue&type=script&lang=js&"
import style0 from "./ModalNuevoMail.vue?vue&type=style&index=0&id=843737fe&scoped=true&lang=css&"
import style1 from "./ModalNuevoMail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843737fe",
  null
  
)

export default component.exports